import {
    Card as MuiCard,
    CardContent,
    withStyles,
    Button,
} from '@material-ui/core'
import { spacing } from "@material-ui/system";
import React from 'react';
import styled from "styled-components/macro";
import { urls, useRouting } from '../routes';
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)(spacing);
const StyledButtonGradient = withStyles({
    root: {
        color: 'rgba(255, 255, 255, 0.95)',
        borderWidth: "1px",
        borderStyle: "solid",
        borderImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
        borderImageSlice: "1"
    },
})(Button);

export const GoToClassify = React.memo((p: {
    id: string
}) => {
    const { id } = p;
    const { routeTo } = useRouting();
    const { t } = useTranslation();
    return (
        <Card style={{ marginTop: "10px" }}>
            <CardContent style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>{t("unitForm_finishedCreation")}</div>
                <StyledButtonGradient onClick={() => routeTo(urls.classify, { id })}>
                    {t("questionnaire")}!
                </StyledButtonGradient>
            </CardContent>
        </Card>
    )
})